import DirectorsOfficers from './Components/DirectorsOfficers'
import SportActivities from './Components/SportActivities'
import SportActivities2 from './Components/SportActivities2'
import SportActivities3 from './Components/SportActivities3'

/**
 * These components are for repeater field sets that required
 * toggle-able elements, these components store the values in an object
 *
 * @param formulateInstance
 */
export default function (formulateInstance) {
	formulateInstance.extend({
		components: {
			DirectorsOfficers,
			SportActivities, // version 1
			SportActivities2, // version 2 (re-coded)
			SportActivities3 // version 3 (teams changed for QBE)
		},
		library: {
			directors_officers: {
				classification: 'directors-officers',
				component: 'DirectorsOfficers'
			},
			sport_activities: {
				classification: 'sport-activities',
				component: 'SportActivities'
			},
			sport_activities2: {
				classification: 'sport-activities',
				component: 'SportActivities2'
			},
			sport_activities3: {
				classification: 'sport-activities',
				component: 'SportActivities3'
			}
		}
	})
}
